module.exports = require("core-js/library/fn/object/get-own-property-descriptors");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@babel/runtime-corejs2/core-js/object/get-own-property-descriptors.js
// module id = 214
// module chunks = 0 1